/**
 * Copyright © 2020 Redbox Digital Limited. All rights reserved.
 */
define('Magento_Catalog/js/action/compare',[
    'jquery',
    'underscore',
    'matchMedia',
    'domReady!'
], function ($, _, mediaCheck) {
    'use strict';
    return {

        /**
         * Click event
         * @param event
         */
        clickShowDifferencesBtn: function (event) {
            this._showDifferences(event.currentTarget);
        },

        /**
         * Click event for mobitle preview
         * @param event
         */
        clickShowDifferencesBtnMobile: function (selector) {
            this._showDifferences(selector);
        },

        /**
         * Checking current data within DOM and comparing/hiding them
         * @param selector
         * @private
         */
        _showDifferences: function (selector) {
            var _self = this;
            if ($(selector).hasClass('_showOnlyDifferences')) {
                $('.phone-spec-row').each(function () {
                    $(this).removeAttr('style');
                });
                $(selector).toggleClass('_showOnlyDifferences');
                return;
            }
            $('.phone-spec-row').each(function () {
                var cells = $(this).children('.cell.product'),
                    dataArray = [];
                cells.each(function () {
                    var values = $(this).data('feature-value');
                    dataArray.push(values);
                })

                if (!_.isEmpty(dataArray)) {
                    _self._isFeatureValueEqual(dataArray, this);
                }
            });

            $('html, body').animate({
                scrollTop: $(".phone-spec-row").offset().top - 150
            }, 500);

            $(selector).toggleClass('_showOnlyDifferences');
        },

        /**
         * Hide same cells in the phone specification table
         * @param dataArray
         * @param selector
         * @private
         */
        _isFeatureValueEqual: function (dataArray, selector) {
            if (_.uniq(dataArray).length === 1) {
                $(selector).hide();
            }
        }
    }
});


